import { render, staticRenderFns } from "./cartao.vue?vue&type=template&id=e67665d8&scoped=true&"
import script from "./cartao.vue?vue&type=script&lang=js&"
export * from "./cartao.vue?vue&type=script&lang=js&"
import style0 from "./cartao.vue?vue&type=style&index=0&id=e67665d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67665d8",
  null
  
)

export default component.exports